import React, {Component} from 'react';
import {Icon, Row, Col} from 'antd';
import {Switch, Route, Redirect} from 'react-router-dom';
import '../css/mallManage.css';
import MyFrame from '../components/Frame';
import MMGoods from "./mall_manage/MMGoods";
import MMAddGood from "./mall_manage/MMAddGood";
import MMEditType from "./mall_manage/MMEditType";
import MMOrderList from "./mall_manage/MMOrderList";
import MMOrderDetail from "./mall_manage/MMOrderDetail";
import {app} from "../app";

function checkMenu(path) {
    let key = '1';
    switch (path) {
        case '/mall-manage/goods':
            key = '1';
            break;
        case '/mall-manage/add-good':
            key = '2';
            break;
        case '/mall-manage/edit-type':
            key = '3';
            break;
        case '/mall-manage/order-list':
            key = '4';
            break;
    }
    if (path.indexOf('/mall-manage/order-detail/') > -1) {
        key = '4';
    }
    return key;
}

class MallManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu_key: checkMenu(props.location.pathname),
            rights: app.getData('rights'),
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data)

    componentWillReceiveProps (nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
        }
    }

    render() {
        const {rights} = this.state;
        if (rights !== 1) {
            return (<Redirect to="/"/>);
        } else {
            const {menu_key} = this.state,
                menuList = [
                    {key: '1', text: '商品管理', link: '/mall-manage/goods', icon: <Icon type="appstore-o"/>},
                    {key: '2', text: '添加商品', link: '/mall-manage/add-good', icon: <Icon type="plus-circle-o"/>},
                    {key: '3', text: '编辑分类', link: '/mall-manage/edit-type', icon: <Icon type="bars"/>},
                    {key: '4', text: '订单管理', link: '/mall-manage/order-list', icon: <Icon type="profile"/>},
                ];
            return (
                <MyFrame className="mall-manage" history={this.props.history} menuList={menuList}
                         menuSelectKey={menu_key}>
                    <Switch>
                        <Route exact path="/mall-manage/goods" component={MMGoods}/>
                        <Route exact path="/mall-manage/add-good" component={MMAddGood}/>
                        <Route exact path="/mall-manage/edit-type" component={MMEditType}/>
                        <Route exact path="/mall-manage/order-list" component={MMOrderList}/>
                        <Route exact path="/mall-manage/order-detail/:id" component={MMOrderDetail}/>
                        <Route render={() => <Redirect to="/mall-manage/goods"/>}/>
                    </Switch>
                </MyFrame>
            );
        }
    }
}

export default MallManage;



// WEBPACK FOOTER //
// ./src/routes/MallManage.jsx